/*** IMPORTS FROM imports-loader ***/
var define = false;

import $ from 'jquery';
import { gsap } from "gsap";
import { SplitText } from "gsap/SplitText";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(SplitText, ScrollTrigger);
// import imagesLoaded from 'imagesloaded';
// import { locoScroll } from "./modules/smooth-scrolling";

// Cursor stuff
// import Cursor from "./modules/cursor";
// import Magnetic from "./modules/magnetic";

// import './modules/smooth-scrolling';
// imagesLoaded(document.querySelector('body'), function (instance) {
//   locoScroll.update();
// });

// Animate On Scroll
// import { animateOnScroll } from './modules/animateOnScroll.js';
// animateOnScroll();

// Don't load on mobile
function is_touch_enabled() {
  return ( 'ontouchstart' in window ) ||
         ( navigator.maxTouchPoints > 0 ) ||
         ( navigator.msMaxTouchPoints > 0 );
}

// Get URL Params
// import './modules/getUrlParams';



// Mobile vs. Desktop controls
if( ! is_touch_enabled() ) {
  // Set up cursor
  // const cursor = new Cursor();
  // $('[data-magnetic]').each(function () {new Magnetic(this);});
} else {
  $('body').addClass('touch');
}

// Load 'em
import { mobileNav } from './modules/mobileNav';
mobileNav();

import { popup } from './modules/popup';
var heroVideoExists = document.querySelector('.heroPopupLink');
if (heroVideoExists) {
  popup();
}

import { videoPopup } from './modules/videoPopup';
var videoPopupExists = document.querySelector('.popupVideoLink');
if (videoPopupExists) {
  videoPopup();
}

import { jobsSlider } from './modules/jobsSlider';
var jobsSliderExists = document.querySelector('.jobsSlider__slider');
if (jobsSliderExists) {
  jobsSlider();
}

import { testimonialsSlider } from './modules/testimonialsSlider';
var testimonialsSliderExists = document.querySelector('.testimonials__slider');
if (testimonialsSliderExists) {
  testimonialsSlider();
}

import { imageTextSlider } from './modules/imageTextSlider';
var imageTextSliderExists = document.querySelector('.imageText__slider');
if (imageTextSliderExists) {
  imageTextSlider();
}

import { imageSlider } from './modules/imageSlider';
var imageSliderExists = document.querySelector('.imageSlider__slider');
if (imageSliderExists) {
  imageSlider();
}

import { contentSlider } from './modules/contentSlider';
var contentSliderExists = document.querySelector('.contentSlider__slider');
if (contentSliderExists) {
  contentSlider();
}

const quotes = document.querySelectorAll(".titleSection__title em");

function setupSplits() {
  $('.titleSection__title em').css('opacity', '1');
  quotes.forEach(quote => {
    // Reset if needed
    if(quote.anim) {
      quote.anim.progress(1).kill();
      quote.split.revert();
    }

    quote.split = new SplitText(quote, {
      type: "lines,words,chars",
      linesClass: "split-line"
    });

    // Set up the anim
    quote.anim = gsap.from(quote.split.chars, {
      scrollTrigger: {
        trigger: quote,
        start: "top 70%",
      },
      duration: 0.6,
      ease: "circ.out",
      y: 80,
      opacity: 0,
      stagger: 0.02,
    });
  });
}

// ScrollTrigger.addEventListener("refresh", setupSplits);
setTimeout(() => {
  setupSplits();
}, 500);
